export { StudentLoansInline } from './StudentLoansInline';
export type {
  StudentLoansInlineCta,
  StudentLoansInlinePartner,
  StudentLoansInlineProps,
  StudentLoansInlineVariant,
} from './types';
